import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, Layout, Row, Typography, Select, Space, Switch, Checkbox, Collapse, Table, Tag, InputNumber, DatePicker } from 'antd';
import { Link } from "react-router-dom";
import { PlusOutlined, FilterOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import Swal from "sweetalert2";

import "./style.scss";
import { cloneDeep } from "lodash";

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;
const { Panel } = Collapse;

const AddCustomEvent = ({ eventStore, userStore }) => {

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const handleSubmitNewEvent = (values) => {

        // Transform teamLeader array into an array of objects with teamLeaderID key
        const formattedValues = {
            eventName: values.eventName,
            date: values.date,
            location: values.location,
            registrationStart: null,
            registrationEnd: null,
            teamleader: [
                {
                    teamLeaderID: userStore.userID
                }
            ]
        };

        Swal.fire({
            title: "Add New Event",
            icon: "info",
            text: "Are you sure do you want to add this Event?",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: `Cancel`
        }).then((result) => {
            if (result.isConfirmed) {
                eventStore.createNewEvent(formattedValues);
            } 
        })
    
    }

    return (
        <div className="admin-add-voter">
            <Content>
                <Form 
                    name="addbillingInformationForm"
                    layout="vertical"
                    form={form} 
                    onFinish={(values) => {
                        const formattedValues = {
                          ...values,
                          date: values.date ? values.date.format("YYYY-MM-DD") : null, // Convert Date to YYYY-MM-DD
                        };
                        handleSubmitNewEvent(formattedValues);
                    }}
                >
                    <div className="admin-add-voter-content">
                        <Title level={4}>Add Event</Title>
                        <Divider />
                        <Row justify={'center'} gutter={10}>
                            <div className="form-container">
                                <Row gutter={10}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Event Name"
                                            name="eventName"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Event Name.',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Event Name"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Event Date"
                                            name="date"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Event Date.',
                                                },
                                            ]}
                                        >
                                            <DatePicker/>
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col span={24}>
                                        <Form.Item
                                            label="Location"
                                            name="location"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Location.',
                                                },
                                            ]}
                                        >
                                            <TextArea placeholder="Enter Location"/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </Row>
                        <Divider/>
                        <Row justify={'end'} gutter={12}>
                            <Col>
                                <Button type="primary" htmlType="submit" icon={<PlusOutlined/>} loading={eventStore.loading}>Submit</Button>
                            </Col>
                            <Col>
                                <Button onClick={() => navigate(-1)} loading={eventStore.loading}>Back</Button>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Content>
        </div>
    );
};

export default inject('userStore', 'eventStore')(observer(AddCustomEvent));
